// extracted by mini-css-extract-plugin
export default {"container":"hc_MA","noMargin":"_25kRP","left":"_3r3U8","wrapper":"_3y3o-","titleWrapper":"_Dmnp","title":"_3MuRX","descriptionWrapper":"Uzu9I","description":"_1BNHs"};